<template>
  <Form
    ref="formValidate"
    :label-width="labelPosition === 'top'? NaN: labelWidth"
    :label-position="labelPosition"
    :model="formData"
    :hide-required-mark="hideRequiredMark"
  >
    <template v-for="(item, index) in formItems">
      <FormItem
        :key="`validate-form-${item.key}-${index}`"
        :label="item.label ? `${item.label}：`: ''"
        :rules="item.rules"
        :prop="item.key"
        :style="{width: item.width||'100%', display: 'inline-block'}"
        :label-width="(item.labelWidth + 10) || undefined"
        v-if="!item.hide"
      >
        <MyFormItem
          :item="item"
          :formItems="formItems"
          :readonly="readonly"
        />
      </FormItem>
    </template>
  </Form>
</template>
<script>
import MyFormItem from '@components/form-item'
export default {
  name: 'validate-form',
  props: {
    formItems: {
      type: Array,
      default: () => []
    },
    labelWidth: {
      type: Number,
      default: 120
    },
    labelPosition: {
      type: String,
      default: 'right'
    },
    readonly: {
      type: Boolean,
      default: false
    },
    hideRequiredMark: {
      type: Boolean,
      default: false
    }
  },
  components: { MyFormItem },
  computed: {
    formData () {
      let formData = {}
      this.formItems.map(s => {
        if (s.type === 'datetimerange') {
          formData[s.time0] = s.value0
          formData[s.time1] = s.value1
        } else if (s.key) {
          formData[s.key] = s.value
        }
      })
      this.$emit('on-form-change', formData)
      return formData
    }
  },
  methods: {
    async submit () {
      const valid = await this.$refs['formValidate'].validate()
      if (valid) {
        return this.formData
      }
    },
    reset () {
      this.formItems.map(s => {
        if (s.type === 'datetimerange') {
          s.value0 = s.value1 = ''
        } else if (s.type === 'checkbox') {
          s.value = []
        } else {
          s.value = null
        }
      })
    }
  }
}
</script>